import s from './ExplanationText.module.scss'
import type { ExplanationTextProps } from './ExplanationText.props'

export function ExplanationText({ data }: ExplanationTextProps) {
  if (!data?.content) return null

  return (
    <div
      className={s.explanationText}
      dangerouslySetInnerHTML={{ __html: data.content }}
    />
  )
}
